module.exports = __webpack_public_path__ + "static/sourcelair-7bd3b9adaac67626798b5e8bfa268fe1.svg";